import { render, staticRenderFns } from "./RouteLogo.vue?vue&type=template&id=53d787d8&"
import script from "./RouteLogo.vue?vue&type=script&lang=js&"
export * from "./RouteLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports